import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9ee3805c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "about" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "useing" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Useing view gradient colors")
], -1))
const _hoisted_3 = { class: "view" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/zRains/Gradientor",
  target: "_blank"
}, "Github", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "power" }, [
  /*#__PURE__*/_createElementVNode("span", null, "zRain | thank you for opening a new issue")
], -1))
const _hoisted_8 = { class: "tech" }
const _hoisted_9 = { class: "vue" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "StandardJS" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "TS" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.Github
        }, null, 8, _hoisted_4),
        _createTextVNode(" View on   "),
        _hoisted_5
      ]),
      _createElementVNode("span", null, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.Me
        }, null, 8, _hoisted_6),
        _createTextVNode("Power by")
      ]),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.Vue
        }, null, 8, _hoisted_10)
      ]),
      _createElementVNode("span", _hoisted_11, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.StandardJS
        }, null, 8, _hoisted_12)
      ]),
      _createElementVNode("span", _hoisted_13, [
        _createElementVNode("img", {
          src: _ctx.state.imgs.TS
        }, null, 8, _hoisted_14)
      ])
    ])
  ]))
}